import { Map, List } from 'immutable';
import { actions } from 'actions/admin/events.js';

const initialState = new Map({
  isFetching: false,
  errors: new List([]),
  data: new List(),
});

export default function adminEventsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.EVENTS_FETCH:
      return state.merge({ isFetching: true });
    case actions.EVENTS_FETCH_SUCCESS: {
      return state.merge({ isFetching: false }).mergeIn(['data'], action.body.results.events);
    }
    case actions.EVENTS_FETCH_FAILURE:
      return state.merge({ isFetching: true });
    default:
      return state;
  }
}
